import React from 'react';
import styled from 'styled-components';

import { AntdButton as Button } from '@yuhuinc/ui-library/';

import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';

import { sizes } from 'helpers/MediaHelper';

const StyledForwardBackContainer = styled.div`
  display: flex;
`;

const StyledFooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  flex-wrap: ${(props) => (props.isFirstPage ? 'nowrap' : 'wrap')};
  row-gap: 16px;
`;

const StyledSaveAndCloseContainer = styled.div`
  display: flex;
  justify-content: ${(props) => (props.isFirstPage ? 'flex-end' : 'center')};
  ${media.mobile`
    width: 100%;
  `};
`;

const LeaseCreatorPageFooter = ({
  forward,
  back,
  currentPage,
  totalPages,
  formName,
  handleCancellation,
  submitLoading = false,
  disablePrimary = false,
  restartWizard = false,
  hidePrimaryButton = false,
}) => {
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;

  const isMobile = window.matchMedia(`(max-width: ${sizes.mobile}px)`).matches;

  return (
    <StyledFooterContainer isFirstPage={isFirstPage || hidePrimaryButton}>
      <StyledForwardBackContainer>
        {!isFirstPage && (
          <Button
            label={
              restartWizard
                ? getTranslatedString('landlordPortal.leaseCreatorV2.leasePreviewPage.edit')
                : getTranslatedString('back')
            }
            style={{ marginRight: '16px' }}
            onClick={() => back()}
            size={isMobile ? 'large' : 'default'}
          />
        )}
        {!hidePrimaryButton && (
          <Button
            form={formName}
            type="primary"
            htmlType={formName ? 'submit' : 'button'}
            label={
              isLastPage
                ? getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leasePreviewPage.previewAndSend'
                  )
                : getTranslatedString('saveAndContinue')
            }
            loading={submitLoading}
            disabled={disablePrimary}
            onClick={() => {
              if (!formName) {
                forward();
              }
            }}
            size={isMobile ? 'large' : 'default'}
          />
        )}
      </StyledForwardBackContainer>
      <StyledSaveAndCloseContainer isFirstPage={isFirstPage || hidePrimaryButton}>
        <Button
          type="text"
          label={getTranslatedString(
            'landlordPortal.leaseCreatorV2.leaseCreatePageFooter.saveAndClose'
          )}
          onClick={() => handleCancellation()}
          size={isMobile ? 'large' : 'default'}
        />
      </StyledSaveAndCloseContainer>
    </StyledFooterContainer>
  );
};

export { LeaseCreatorPageFooter };
